<template>
  <div class="carousel">
    <div v-if="images.length > 1" class="arrow arrow-left" @click="prev()" />
    <div v-if="images.length > 1" class="arrow arrow-right" @click="next()" />
    <div class="images">
      <img
        v-for="(image, index) in images"
        :key="image + index"
        :src="image"
        :class="{ active: active === index }" />
    </div>

    <div
      v-if="images.length > 1"
      class="carousel-navigation">
      <div
        v-for="(img, i) in images"
        :key="i"
        class="dot"
        :class="{ active: i === active }"
        @click="setActive(i)" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true
    },

    interval: {
      type: Number,
      default: 6000
    }
  },

  data () {
    return {
      active: 0,

      timer: null
    }
  },

  watch: {
    images () {
      this.setActive(0)
    }
  },

  created () {
    this.startTimer()
  },

  methods: {
    setActive (i) {
      this.active = i
      this.startTimer()
    },

    startTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.next()
      }, this.interval)
    },

    next () {
      this.setActive(this.active === this.images.length - 1 ? 0 : this.active + 1)
    },

    prev () {
      this.setActive(this.active === 0 ? this.images.length - 1 : this.active - 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .carousel {
    display: block;
    width: 100%;
    height: 0;
    padding-bottom: 50%;
    background-color: #d4d4d4;
    border-radius: 30px;
    margin-top: 20px;
    overflow: hidden;
    position: relative;

    .arrow {
      position: absolute;
      top: 50%;
      z-index: 2;
      width: 25px;
      height: 35px;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      opacity: .7;
      transform: translate(0, -50%);
      &:hover {
        opacity: 1;
      }
      &.arrow-left {
        left: 10px;
        background-image: url(../assets/images/GeneralAssets/arrow-left-white.png);
      }
      &.arrow-right {
        right: 10px;
        background-image: url(../assets/images/GeneralAssets/arrow-right-white.png);
      }
    }
    .images {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;
        transition: all 0.3s ease;
        object-fit: contain;
        object-position: center;
        opacity: 0;
        &.active {
          opacity: 1;
          transition: all 0.3s ease;
        }
      }
    }

    .carousel-navigation {
      position: absolute;
      bottom: 25px;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .dot {
        width: 12px;
        height: 12px;
        background-color: #fff;
        opacity: .6;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.3s ease;
        margin: 0 4px;
        &.active {
          opacity: 1;
        }
      }
    }
  }
</style>
